import { h } from 'preact'
import formatDateInLocalTimezone from '../utils/dateFormatting'
import classNames from 'classnames'

type Props = {
  editedAt: string,
  editedBy: string,
  isLatest: boolean,
  isSelected: boolean,
  onClick: (editedAt: string) => void
}

export default ({ editedAt, editedBy, isLatest, isSelected, onClick }: Props) =>
  <div
    class={classNames('article-versions__edit', isSelected && 'selected')}
    onClick={() => onClick(editedAt)}
  >
    <div class='article-versions__edit-header'>
      <div class='article-versions__edit-date'>{formatDateInLocalTimezone(editedAt)}</div>
      {isLatest && <div class='article-versions__edit-latest'>Current Version</div>}
    </div>
    <div class='article-versions__edit-editor'>{editedBy}</div>
  </div>
